export default "__VITE_ASSET__CPt60nBc__"